/**
 * System Prompts API
 * ==================
 * API functions for system prompt management with version history
 */

import apiClient from './client';

const BASE = '/api/v1/system/prompts';

/**
 * Get all system prompts with optional filtering
 */
export const getPrompts = async (params = {}) => {
  const response = await apiClient.get(BASE, { params });
  return response.data;
};

/**
 * Get a single system prompt by name
 */
export const getPrompt = async (promptName) => {
  const response = await apiClient.get(`${BASE}/${promptName}`);
  return response.data;
};

/**
 * Update an existing system prompt
 */
export const updatePrompt = async (promptName, updateData) => {
  const response = await apiClient.patch(`${BASE}/${promptName}`, updateData);
  return response.data;
};

/**
 * Get version history for a prompt
 */
export const getPromptHistory = async (promptName) => {
  const response = await apiClient.get(`${BASE}/${promptName}/history`);
  return response.data;
};

/**
 * Get a specific version of a prompt
 */
export const getPromptVersion = async (promptName, versionNumber) => {
  const response = await apiClient.get(`${BASE}/${promptName}/history/${versionNumber}`);
  return response.data;
};

/**
 * Revert a prompt to a previous version
 */
export const revertPrompt = async (promptName, versionNumber) => {
  const response = await apiClient.post(`${BASE}/${promptName}/revert`, { version_number: versionNumber });
  return response.data;
};

const systemPromptAPI = {
  getPrompts,
  getPrompt,
  updatePrompt,
  getPromptHistory,
  getPromptVersion,
  revertPrompt,
};

export default systemPromptAPI;
